import {ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Params, Router} from '@angular/router';
import * as moment from 'moment/moment';
import {CompanyService} from '../../services/company.service';
import {Company} from '../../../dto/company';
import {PartnerCounterService} from '../../services/partner-counter.service';
import {PartnerInvoice, PartnerInvoiceLineItem} from '../../../dto/partnerCounter';
import {ToastService} from 'angular-toastify';

@Component({
  selector: 'app-partner-counter-create-invoice',
  templateUrl: './partner-counter-create-invoice.component.html',
  styleUrls: ['./partner-counter-create-invoice.component.css']
})
export class PartnerCounterCreateInvoiceComponent implements OnInit {


  companyId: number;
  company: Company|null;
  month: number;
  year: number;
  invoicePreview: PartnerInvoice|null;
  displayedColumns: string[] = ['del',  'description', 'numberOfItems', 'netAmountPerItem', 'currency', 'netTotal'];
  lineItemCodes: string[] = [];

  invoiceLineItems: PartnerInvoiceLineItem[] = [];
  commissionLineItems: PartnerInvoiceLineItem[] = [];
  isLoading = false;


  constructor(
    private companyService: CompanyService,
    private route: ActivatedRoute,
    private router: Router,
    private partnerCounterService: PartnerCounterService,
    private _toastService: ToastService,
    private changeDetectorRefs: ChangeDetectorRef
  ) { }


  ngOnInit(): void {

    this.companyId = parseInt(this.route.snapshot.paramMap.get('companyId'));
    this.route.queryParams.subscribe((params: Params) => {
      let month = parseInt(params['month']);
      let year = parseInt(params['year']);

      const now = moment().toDate();
      if ( isNaN(month)) {
month = now.getMonth() + 1;
}
      if ( isNaN(year)) {
year = now.getFullYear();
}

      this.month = month;
      this.year = year;



      this.loadData();

    });

  }

  private loadData(): void {
    this.isLoading = true;
    this.companyService.get(this.companyId).subscribe(data => {
      this.company = data;

      this.partnerCounterService.getLineItemCodes().subscribe(data => {
        this.lineItemCodes = data;
      });

      this.partnerCounterService.getForCompanyInvoicePreview(this.company.id, this.year, this.month).subscribe(data => {
        this.invoicePreview = data;

        const inv: PartnerInvoiceLineItem[] = [];
        const com: PartnerInvoiceLineItem[] = [];

        this.invoicePreview.lineItems.forEach((item) => {

          if ( item.type === 1 ) {
inv.push(item);
} else if ( item.type === 2 ) {
com.push(item);
}
        });

        this.invoiceLineItems = inv;
        this.commissionLineItems = com;


        this.isLoading = false;
      });

    });
  }

  goBack() {
    this.router.navigate(['..'], {
      relativeTo: this.route,
    });
  }

  createInvoice() {

    this.isLoading = true;

    this.invoicePreview.lineItems = [];
    this.invoicePreview.lineItems = [...this.invoiceLineItems, ...this.commissionLineItems];

    this.partnerCounterService.createInvoice(this.companyId, this.invoicePreview, this.year, this.month).subscribe(data => {
      this._toastService.success('invoice created');

      this.isLoading = false;
      this.router.navigate(['administration', 'partner-counter', this.companyId, 'invoice', data.id]);


    });

  }

  addItemToInvoice() {
    const newItem = new PartnerInvoiceLineItem();
    newItem.code = '';
    newItem.netAmountPerItem = 0;
    newItem.numberOfItems = 1;
    newItem.description = '(enter description here)';
    newItem.currencyCode = 978;

    this.invoicePreview.lineItems.push(newItem);
    this.invoiceLineItems.push(newItem);
    this.invoiceLineItems = [...this.invoiceLineItems];


  }

  addItemToCommission() {
    const newItem = new PartnerInvoiceLineItem();
    newItem.type = 2;
    newItem.code = '';
    newItem.netAmountPerItem = 0;
    newItem.numberOfItems = 1;
    newItem.description = '(enter description here)';
    newItem.currencyCode = 978;

    this.invoicePreview.lineItems.push(newItem);

    this.commissionLineItems.push(newItem);
    this.commissionLineItems = [...this.commissionLineItems];

  }

  deleteItemFromInvoice(item: PartnerInvoiceLineItem) {
    const index = this.invoicePreview.lineItems.indexOf(item, 0);
    if (index > -1) {
      this.invoicePreview.lineItems.splice(index, 1);
      this.invoicePreview.lineItems = [...this.invoicePreview.lineItems];

      this._toastService.info('Item \''+item.description+'\' was removed');

    }

  }
}
